// ✅ CheckOutPage.js — Visitor Check-Out Screen (UI Only)

import React, { useState } from "react";

function CheckOutPage() {
  const [search, setSearch] = useState("");

  const visitors = [
    {
      id: 3,
      name: "Sanjay Singh",
      company: "IBM",
      host: "IBM Support",
      checkIn: "10:10 AM",
    },
  ];

  const filtered = visitors.filter((v) =>
    v.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container-fluid py-3">

      {/* HEADER */}
      <div
        className="p-4 mb-4 shadow-sm"
        style={{
          borderRadius: "20px",
          background:
            "linear-gradient(95deg,#6366f1 0%, #8b5cf6 40%, #d946ef 100%)",
          color: "#fff",
        }}
      >
        <h3 className="fw-bold mb-1">Visitor Check-Out</h3>
        <small className="opacity-75">
          View checked-in visitors and record check-out time
        </small>
      </div>

      {/* SEARCH */}
      <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "20px" }}>
        <div className="card-body d-flex gap-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search visitor / company / host..."
            style={{
              borderRadius: "999px",
              padding: "0.85rem 1.2rem",
              border: "1px solid #e5e7eb",
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
            }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* LIST */}
      <div className="card shadow-sm" style={{ borderRadius: "20px" }}>
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Visitor</th>
                <th>Company</th>
                <th>Host</th>
                <th>In Time</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((v, i) => (
                <tr key={v.id}>
                  <td>{i + 1}</td>
                  <td>{v.name}</td>
                  <td>{v.company}</td>
                  <td>{v.host}</td>
                  <td>{v.checkIn}</td>
                  <td>
                    <button
                      className="btn btn-danger btn-sm fw-semibold rounded-pill px-3"
                      onClick={() => alert("Checked-Out (UI Only)")}
                    >
                      Check-Out
                    </button>
                  </td>
                </tr>
              ))}

              {filtered.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-4">
                    No visitors pending checkout.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}

export default CheckOutPage;
